module.exports = __webpack_public_path__ + "static/img/slider-xray-1.5eedf8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/color-theme/img/slider/slider-xray-1.jpg
// module id = sSPs
// module chunks = 1